import CustomTable from 'pages/Event/EventWater/CustomTable'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'
import React from 'react'
import { Pagination } from '@material-ui/lab'
import { useTranslation } from 'react-i18next'

function BoatRacingRank({
	columnsRank,
	dataTableRanks,
	dataTableMyRanks,
	isLoadingRank,
	rankData,
	userData,
	onChangePage,
	current,
	totalPages,
}) {
	const { t } = useTranslation()
	return (
		<div className="box-tab-content-detail">
			<div className="wapper-detail rank">
				<div className="wapper-detail-box">
					<CustomTable
						columns={columnsRank}
						dataSource={dataTableRanks}
						pagination={false}
						scroll={{ x: true }}
						className="table-rank"
						rowClassName={(record, index) => {
							if (record.msisdn === userData?.msisdn) {
								return 'row-current-user'
							}
						}}
						bordered
					/>
					{dataTableRanks.length === 0 && !isLoadingRank && (
						<div className="wapper-detail-box-nodata">
							<img
								className="img--no-data"
								src={noDataIcon}
								alt="No reward is found"
							/>
						</div>
					)}
          {totalPages > 1 && (
						<div className="wapper-detail-box-pagination">
							<Pagination
								count={totalPages}
								shape="rounded"
								size="small"
								page={current || 1}
								onChange={(event, page) => onChangePage(page)}
							/>
						</div>
					)}
					{userData && !isLoadingRank && dataTableMyRanks?.length > 0 && (
						<div className="wapper-detail-box-current-rank">
							<div className="wapper-detail-box-current-rank-title">
								{t('event.boat_racing.rank.my_rank')}
							</div>
							<CustomTable
								columns={columnsRank}
								dataSource={dataTableMyRanks}
								pagination={false}
								scroll={{ x: true }}
								isShowTitle={false}
								bordered
								className="table-rank-current"
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

export default BoatRacingRank
